import React, { useState } from 'react'
import Storage from 'util/store/Storage'
import Axios from 'axios'
import Server from 'util/Server'
import { useSessionStorage } from 'hooks/useSessionStorage'
import { Typography, Button } from 'antd'
import { UserOutlined, LogoutOutlined, ProfileOutlined } from '@ant-design/icons'
import ModalUserInfo from './ModalUserInfo'

const UserInfo = ({ closeDrawer }) => {
  const [userInfoModalOpen, setUserInfoModalOpen] = useState(false)
  const { clearSessionStorage } = useSessionStorage()

  const handleCerrarSesion = () => {
    const ntoken = sessionStorage.getItem('token')
    Axios.delete(Server.host + Server.puertoApp + '/api/v1/', { headers: { Authorization: ntoken } })
      .then(response => {})
      .catch(function (error) {
        console.log(error)
      })
    clearSessionStorage()
    window.location.reload()
  }

  const handleViewProfile = () => {
    if (closeDrawer) {
      closeDrawer()
    }
    setUserInfoModalOpen(true)
  }

  let { usuario } = Storage.getState()

  return (
    <>
      <ModalUserInfo open={userInfoModalOpen} setOpen={setUserInfoModalOpen} />
      <div style={{ width: '100%', padding: '24px 16px 16px 16px', backgroundColor: '#5E60CE' }}>
        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
         

        </div>

        {/* Imagen del navbar y nombre de usuario - sin animación */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
          <UserOutlined style={{ color: '#FFFFFF', fontSize: '18px' }} />
          <Typography style={{ color: '#FFFFFF', fontSize: '14px', fontWeight: 500 }}>
            {usuario?.usuario || 'No info'}
          </Typography>
        </div>

        {/* Botones de acción */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Button
            type="text"
            icon={<ProfileOutlined />}
            onClick={handleViewProfile}
            style={{
              color: '#FFFFFF',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              backgroundColor: 'transparent',
              width: '100%',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 12px',
              height: 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#5149AB'
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)'
            }}
          >
            Ver Perfil
          </Button>
          <Button
            type="text"
            icon={<LogoutOutlined />}
            onClick={handleCerrarSesion}
            style={{
              color: '#FFFFFF',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              backgroundColor: 'transparent',
              width: '100%',
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '8px 12px',
              height: 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#5149AB'
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent'
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)'
            }}
          >
            Cerrar Sesión
          </Button>
        </div>
      </div>
    </>
  )
}

export default UserInfo
